export const AUTHOR_ROLE = {
  OWNER: 'owner' as const,
  MEMBER: 'member' as const,
  ANONYMOUS: 'anonymous' as const,
};
